import React from 'react';

interface Props {
  width?: number;
  height?: number;
}

const Accordion = ({ width = 49, height = 35 }: Props) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 59 45"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g filter="url(#filter_accordion_icon)">
      <rect
        x="56.0455"
        width="40.0682"
        height="54.0455"
        rx="2"
        transform="rotate(90 56.0455 0)"
        fill="#59C3C3"
      />
      <path
        d="M2 2C2 0.895431 2.89543 0 4 0H54.0455C55.15 0 56.0455 0.895431 56.0455 2V7.45455H2V2Z"
        fill="#46AEAE"
      />
      <path d="M2 26.0908H56.0455V33.5454H2V26.0908Z" fill="#46AEAE" />
      <path
        d="M2 34.4775H56.0455V39.0003C56.0455 40.1048 55.15 41.0003 54.0455 41.0003H4C2.89543 41.0003 2 40.1048 2 39.0003V34.4775Z"
        fill="#46AEAE"
      />
      <rect x="10.3864" y="2.79541" width="20.5" height="1.86364" rx="0.931818" fill="#6DD8D8" />
      <rect x="10.3864" y="28.8862" width="29.8182" height="1.86364" rx="0.931818" fill="#6DD8D8" />
      <rect x="10.3864" y="36.3408" width="15.8409" height="1.86364" rx="0.931818" fill="#6DD8D8" />
      <rect x="22.5" y="12.1138" width="30.75" height="0.931818" rx="0.465909" fill="#A0E9E9" />
      <rect x="22.5" y="17.7046" width="30.75" height="0.931818" rx="0.465909" fill="#A0E9E9" />
      <rect x="22.5" y="14.9092" width="30.75" height="0.931818" rx="0.465909" fill="#A0E9E9" />
      <rect x="22.5" y="20.5" width="22.3636" height="0.931818" rx="0.465909" fill="#A0E9E9" />
      <circle cx="6.65911" cy="3.72741" r="1.86364" fill="#6DD8D8" />
      <circle cx="6.65911" cy="29.8182" r="1.86364" fill="#6DD8D8" />
      <circle cx="6.65911" cy="37.2728" r="1.86364" fill="#6DD8D8" />
      <rect x="8.52274" y="12.1138" width="10.25" height="9.31818" rx="1" fill="#A0E9E9" />
    </g>
    <defs>
      <filter
        id="filter_accordion_icon"
        x="0"
        y="0"
        width="58.0455"
        height="45.0003"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dy="2" />
        <feGaussianBlur stdDeviation="1" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.2 0 0 0 0 0.215686 0 0 0 0 0.270588 0 0 0 0.08 0"
        />
        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow" />
        <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow" result="shape" />
      </filter>
    </defs>
  </svg>
);

export default Accordion;
